{
  "name": "syrc-web",
  "version": "1.7.2.1102",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --open",
    "build": "ng build",
    "watch": "ng build --watch --configuration syrc-dev",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage --coverageReporters=lcov --coverageReporters=html --coverageReporters=text-summary",
    "test:ci": "jest --coverage --ci",
    "lint": "eslint \"src/**/*.{js,ts}\"",
    "stylelint": "stylelint \"src/**/*.{css}\"",
    "format": "prettier --write \"src/**/*.{js,ts,css,scss}\"",
    "prestart": "npm run lint",
    "prebuild": "npm run lint",
    "lint:fix": "eslint \"src/**/*.{js,ts}\" --fix",
    "precommit": "npm run stylelint && npm run prettier && npm run lint",
    "lint-staged": "npx lint-staged",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.0.1",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.0.0",
    "@angular/compiler": "^18.0.0",
    "@angular/core": "^18.0.0",
    "@angular/forms": "^18.0.0",
    "@angular/localize": "^18.0.0",
    "@angular/material": "^18.2.14",
    "@angular/platform-browser": "^18.0.0",
    "@angular/platform-browser-dynamic": "^18.0.0",
    "@angular/router": "^18.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@ngxs/devtools-plugin": "^18.0.0",
    "@ngxs/storage-plugin": "^18.0.0",
    "@ngxs/store": "^18.0.0",
    "@openfeature/angular-sdk": "^1.2.0",
    "@openfeature/config-cat-web-provider": "^0.2.0",
    "@progress/kendo-angular-buttons": "^16.2.0",
    "@progress/kendo-angular-common": "^16.2.0",
    "@progress/kendo-angular-dateinputs": "^16.2.0",
    "@progress/kendo-angular-dropdowns": "^16.2.0",
    "@progress/kendo-angular-excel-export": "^16.2.0",
    "@progress/kendo-angular-grid": "^16.2.0",
    "@progress/kendo-angular-icons": "^16.2.0",
    "@progress/kendo-angular-inputs": "^16.2.0",
    "@progress/kendo-angular-intl": "^16.2.0",
    "@progress/kendo-angular-l10n": "^16.2.0",
    "@progress/kendo-angular-label": "^16.2.0",
    "@progress/kendo-angular-layout": "^16.2.0",
    "@progress/kendo-angular-listview": "^16.2.0",
    "@progress/kendo-angular-navigation": "16.2.0",
    "@progress/kendo-angular-pager": "^16.2.0",
    "@progress/kendo-angular-pdf-export": "^16.2.0",
    "@progress/kendo-angular-popup": "^16.2.0",
    "@progress/kendo-angular-treeview": "^16.2.0",
    "@progress/kendo-angular-utils": "^16.2.0",
    "@progress/kendo-data-query": "^1.7.0",
    "@progress/kendo-drawing": "^1.17.2",
    "@progress/kendo-font-icons": "^3.0.0",
    "@progress/kendo-licensing": "^1.0.2",
    "@progress/kendo-svg-icons": "^3.0.0",
    "@progress/kendo-theme-bootstrap": "^8.1.0",
    "@progress/kendo-theme-default": "^8.0.1",
    "@types/lodash": "^4.17.6",
    "@types/moment": "^2.13.0",
    "angular-auth-oidc-client": "^19.0.0",
    "aws-amplify": "^6.3.8",
    "bootstrap": "^5.3.3",
    "country-state-city": "^3.2.1",
    "d3": "^7.9.0",
    "date-fns": "^3.6.0",
    "date-fns-tz": "^3.1.3",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "html2canvas": "^1.4.1",
    "jspdf": "^2.5.2",
    "lodash": "^4.17.21",
    "luxon": "^3.5.0",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.45",
    "ng2-file-upload": "^7.0.1",
    "ngx-file-drop": "^16.0.0",
    "ngx-toastr": "^19.0.0",
    "plotly.js": "^2.35.2",
    "plotly.js-dist": "^2.35.2",
    "rxjs": "~7.8.0",
    "syrc-web": "file:",
    "terra-draw": "1.35.0",
    "terra-draw-google-maps-adapter": "1.6.2",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.0.3",
    "@angular/cli": "^18.0.2",
    "@angular/compiler-cli": "^18.0.0",
    "@angular/localize": "^18.0.1",
    "@types/d3": "^7.4.3",
    "@types/google.maps": "^3.58.1",
    "@types/googlemaps": "^3.43.2",
    "@types/jest": "^29.5.12",
    "@types/luxon": "^3.4.2",
    "angular-eslint": "18.0.1",
    "eslint": "^9.3.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "husky": "^9.0.11",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.1.0",
    "lint-staged": "^15.2.7",
    "npm-run-all": "^4.1.5",
    "prettier": "^3.3.2",
    "stylelint": "^14.0.0",
    "stylelint-config-prettier": "^9.0.0",
    "stylelint-config-standard": "^25.0.0",
    "stylelint-order": "^5.0.0",
    "stylelint-prettier": "^2.0.0",
    "typescript": "~5.4.2",
    "typescript-eslint": "8.0.0-alpha.20"
  },
  "volta": {
    "node": "20.20.2"
  }
}
